import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CatalogTaxRef } from "./CatalogTaxRef";
import type { CatalogTaxStaff } from "./CatalogTaxStaff";
import type { LineItemStaff } from "./LineItemStaff";
import type { LineItemTaxAmountsBase } from "./LineItemTaxAmountsBase";
import type { LineItemTaxDTOBase } from "./LineItemTaxDTOBase";
import type { TrackedModernBase } from "./TrackedModernBase";

export class LineItemTaxStaff implements LineItemTaxDTOBase, TrackedModernBase, LineItemTaxAmountsBase {
  constructor(public readonly assignId: number, public readonly amountPaidCents: number | null, public readonly amountRefundedCents: number | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly unitAmountTaxableCents: number | null, public readonly amountBaseCents: number | null, public readonly amountTotalCents: number | null, public readonly amountToRefundCents: number | null, public readonly taxRateUsed: string | null, public readonly lineItemId: LineItemStaff | null, public readonly taxId: CatalogTaxStaff | null, public readonly taxIdTargetIds: CatalogTaxRef) {
    this.cbiServiceContext = null;
    this.lineItemIdLoaded = this.lineItemId != null;
    this.lineItemIdCached = this.lineItemId;
    this.taxIdLoaded = this.taxId != null;
    this.taxIdCached = this.taxId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private lineItemIdLoaded: boolean;
  private lineItemIdCached: LineItemStaff | null;
  private taxIdLoaded: boolean;
  private taxIdCached: CatalogTaxStaff | null;
  async lineItemIdLazy(): Promise<LineItemStaff> {
    if (!this.lineItemIdLoaded) {
      this.lineItemIdCached = await this.cbiServiceContext!.orderService().getLineItemTaxStaffLineItemId(this.assignId);
      this.lineItemIdLoaded = true;
    }
    return this.lineItemIdCached!;
  }
  async taxIdLazy(): Promise<CatalogTaxStaff> {
    if (!this.taxIdLoaded) {
      this.taxIdCached = await this.cbiServiceContext!.taxService().getCatalogTaxStaff(this.taxIdTargetIds.assignId);
      this.taxIdLoaded = true;
    }
    return this.taxIdCached!;
  }
}
